<template>
    <svg aria-hidden="true" focusable="false" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path
            d="M11.3182 9.98873H12.6818V18H11.3182V9.98873ZM11 7.11549C11 6.81127 11.096 6.55211 11.2879 6.33803C11.4899 6.11268 11.7273 6 12 6C12.2727 6 12.5051 6.11268 12.697 6.33803C12.899 6.55211 13 6.81127 13 7.11549C13 7.41972 12.899 7.68451 12.697 7.90986C12.5051 8.12394 12.2727 8.23099 12 8.23099C11.7273 8.23099 11.4899 8.12394 11.2879 7.90986C11.096 7.68451 11 7.41972 11 7.11549Z"
            fill="black" />
    </svg>
</template>
